import { useRef } from 'react';

const toLocalInputValue = (value: string | null): string => {
  if (!value) return '';
  const date = new Date(value);
  const offset = date.getTimezoneOffset() * 60_000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
};

const DateTimeTag = ({
  value,
  label,
  onChange,
  disabled,
}: {
  value: string | null;
  label: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  return (
    <span className="quick-bookmark-date-control">
      <button
        type="button"
        className="quick-bookmark-tag"
        disabled={disabled}
        onClick={() => {
          const input = inputRef.current;
          if (!input) return;
          input.showPicker();
        }}
      >
        {label}
      </button>
      <input
        ref={inputRef}
        className="quick-bookmark-date-input"
        type="datetime-local"
        value={toLocalInputValue(value)}
        onChange={(event) => {
          if (!event.target.value) return;
          onChange(new Date(event.target.value).toISOString());
        }}
        tabIndex={-1}
        aria-hidden="true"
      />
    </span>
  );
};

export default DateTimeTag;
